import { IconButton } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'

import { useChangesetStateContext } from '../../../../context/changesetStateContext'
import { useNavigationParams } from '../../../../system/useNavigationParams'
import { useOperationsContext } from '../../../../workspace/operationsContext'

export const ToggleBranchChangesetsState = () => {
  const translate = useTranslate()
  const { onReset, areAllChangesetsDisabled, onDisableAll } =
    useChangesetStateContext()
  const { branchKey } = useOperationsContext()
  const { branch: currentBranch, server } = useNavigationParams()
  const isCurrentBranch =
    currentBranch &&
    branchKey &&
    currentBranch === branchKey.name &&
    server === branchKey.server

  return isCurrentBranch ? (
    <IconButton
      iconName={areAllChangesetsDisabled ? 'EyeSlash' : 'Eye'}
      onClick={areAllChangesetsDisabled ? onReset : onDisableAll}
      isDanger={areAllChangesetsDisabled}
      tip={
        areAllChangesetsDisabled
          ? translate('changesetState.tooltip.showAll')
          : translate('changesetState.tooltip.hideAll')
      }
    />
  ) : null
}
